var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBscNetworkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 256 256",
    fill: "none",
    id: "bsc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.975 128.248L46.1072 176.697L87.2743 200.922V229.287L22.0147 191.012V114.08L45.975 128.248ZM45.975 79.7989V108.032L22 93.8492V65.6165L45.975 51.4341L70.0675 65.6165L45.975 79.7989ZM104.466 65.6165L128.441 51.4341L152.534 65.6165L128.441 79.7989L104.466 65.6165Z",
    fill: "#F0B90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2991 166.655V138.29L87.2741 152.473V180.705L63.2991 166.655ZM104.466 211.082L128.441 225.264L152.534 211.082V239.314L128.441 253.497L104.466 239.314V211.082ZM186.918 65.6165L210.893 51.4341L234.985 65.6165V93.8492L210.893 108.032V79.7989L186.918 65.6165ZM210.893 176.697L211.025 128.248L235 114.066V190.997L169.741 229.272V200.907L210.893 176.697Z",
    fill: "#F0B90B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.701 166.655L169.726 180.706V152.473L193.701 138.291V166.655Z",
    fill: "#F0B90B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.701 89.8415L193.833 118.206L152.548 142.431V190.998L128.573 205.048L104.598 190.998V142.431L63.3138 118.206V89.8415L87.3915 75.6591L128.427 100.001L169.711 75.6591L193.804 89.8415H193.701ZM63.2991 41.407L128.441 3L193.701 41.407L169.726 55.5894L128.441 31.2474L87.2741 55.5894L63.2991 41.407Z",
    fill: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscNetworkIcon);
export default __webpack_public_path__ + "static/media/bsc-network-icon.fa4bea56fdb4a31ab5e20d0ec3951b49.svg";
export { ForwardRef as ReactComponent };